<template>
  <v-app-bar :color="color">
    <template v-slot:image>
      <v-img
        gradient="to top right, rgba(19,84,122,.8), rgba(128,208,199,.8)"
      ></v-img>
    </template>
    <v-btn variant="outlined" to="/main"
      ><v-icon>mdi-arrow-left-top-bold</v-icon></v-btn
    >
    <v-app-bar-title>
      <h1>
        {{ title }}

        <div class="float-right mr-5">
          <v-icon
            v-if="page <= 7"
            class="ml-2 my-auto"
            :color="!is_lock_kmitl1 ? 'white' : 'error'"
            >mdi-{{ !is_lock_kmitl1 ? "lock-open-outline" : "lock" }}
          </v-icon>
          <v-icon
            v-if="page == 8"
            class="ml-2 my-auto"
            :color="!is_lock_photo ? 'white' : 'error'"
            >mdi-{{ !is_lock_photo ? "lock-open-outline" : "lock" }}
          </v-icon>
          <v-icon
            v-if="page == 9"
            class="ml-2 my-auto"
            :color="!is_lock_document ? 'white' : 'error'"
            >mdi-{{ !is_lock_document ? "lock-open-outline" : "lock" }}
          </v-icon>
        </div>
      </h1>
    </v-app-bar-title>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "teal-darken-4",
    },
  },

  computed: {
    is_lock_kmitl1() {
      let data = true;
      let LOCK_KMITL1 = parseInt(
        this.$store.state.user.surrogated_student_info.LOCK_KMITL1
      );
      if (LOCK_KMITL1 === 0) {
        data = false;
      }
      return data;
    },
    is_lock_photo() {
      let data = true;
      let LOCK_PHOTO = parseInt(
        this.$store.state.user.surrogated_student_info.LOCK_PHOTO
      );
      if (LOCK_PHOTO === 0) {
        data = false;
      }
      return data;
    },
    is_lock_document() {
      let data = true;
      let LOCK_UPLOAD = parseInt(
        this.$store.state.user.surrogated_student_info.LOCK_UPLOAD
      );
      if (LOCK_UPLOAD === 0) {
        data = false;
      }
      return data;
    },
  },
};
</script>

<style scoped>
/* Add your custom styles here */
</style>
